module.exports = __webpack_public_path__ + "img/52_37.59728de8.png";